export default __webpack_public_path__ + "static/media/1.daf8e9be.jpg";